<div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 flexchild">
        <div class="border-div box-height deal-calander">
          <div class="d-flex chart-box-header margin-bottom-30 align-item-center">
            <h2 class="mainhead" *ngIf="!isFromPrincipalDashboard">
              <span class="text">Deal Calendar</span>
            </h2>
            <h2 class="mainhead" *ngIf="isFromPrincipalDashboard">
              <span class="text">Calendar</span>
            </h2>
          </div>

            <div *ngIf="showDealsCalendar">
                <ul class="deal-list cf">
                    <li *ngFor="let item of calendarData">
                        <div class="date-wrap d-flex align-item-center">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                            <div class="date-inner d-flex">
                                <span class="date">{{Validation.convertUTCDateToLocalDate(item.DueFrom) | date :'dd'}}</span>
                                <span class="month">{{Validation.convertUTCDateToLocalDate(item.DueFrom) | date :'MMM'}}</span>
                            </div>
                        </div>
                        <div class="d-flex task-wrap">
                          <span class="task"><a class="blue-text" href="javascript:void(0);" (click)="gotoOfferDetails(item.Guid)">{{item.TaskName}}</a></span>
                          <span class="update-time tenant-info" *ngIf="haveaccesstoviewlocation">{{item.Tenant}}</span>
                          <span class="update-time tenant-info" *ngIf="!haveaccesstoviewlocation">{{item.ConfidentialLocation ? item.TenantName +' - Confidential' :item.Tenant}}</span>
                          <span class="update-time">Updated : {{Validation.convertUTCDateToLocalDate(item.AssignedOn) | date :'d MMMM y'}}</span>
                        </div>
                        <div class="rt ml-auto" *ngIf="item.LeadChecklistId">
                            <a class="bluetwo note-icon" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle sharednotesmodal',item.LeadDetailId,item.LeadChecklistId, item.AssociatedStatusName)" placement="left" tooltip="Notes"><i aria-hidden="true" class="icon-inquiry"></i></a>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="nodata" *ngIf="calendarData?.length == 0&&!isFromPrincipalDashboard">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No Data Available</p>
            </div>
            <div class="principle-box" *ngIf="calendarData?.length == 0&&isFromPrincipalDashboard">
              Manage critical dates and tasks. Use your Calendar with your broker and deal team to stay on
              top of active deadlines for all acquisitions & dispositions with B+E.
              
            </div>
        </div>
    </div>

    <ng-template #notestemplate>
        <app-shared-add-notes (close)="closeModal" [modalRef]="modalRefNotes" [notesInputsModel]="NotesInput"></app-shared-add-notes>
    </ng-template>

    <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 flexchild" *ngIf="!isFromPrincipalDashboard">
        <div class="border-div box-height" id="divSubcategoryMarketShare">
            <div class="d-flex chart-box-header margin-bottom-30 align-item-center">
                <h2 class="mainhead">
                    <span class="text">Upload Files</span>
                </h2>
            </div>

            <div class="offredetailspage section-margin">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="floatinghead clearfix">
                                <app-upload-files [uploadType]="fileUploadType" [messageDisplayes]="1"  (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [fileDocExt]="'pdf,xlsx,doc,docx,xls,txt,dwg'" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes] ="fileTypes"></app-upload-files>
                            </div>
                            <div class="table-responsive">
                                <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
                                    <thead>
                                        <tr>
                                            <th class="minwidth40">File</th>
                                            <th class="minwidth40">Property</th>
                                            <th class="minwidth20">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let file1 of filesCollection;let i = index" [attr.data-index]="i">
                                          <td><p>{{file1.name}}</p></td>
                                            <td>
                                                <label class="select">
                                                    <select #myprop class="form-control" [(ngModel)]="file1.propertyId" (change)="fileChange(file1,myprop);">
                                                        <option [ngValue]="0">--Select--</option>
                                                        <option value="{{item.Id}}" *ngFor="let item of properties" >{{item.Name}}</option>
                                                    </select>
                                                    <i></i>
                                                </label>
                                            </td>
                                            <td>
                                                <a class="remove" href="javascript:void(0);" (click)="removeImage(i,$event)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <div class="text-right" *ngIf="filesCollection.length > 0">
                                <button type="button" class="btn btn-default  btn-lg" (click)="onFilesClear();">Clear All</button>
                                <button class="btn btn-success  btn-lg" (click)="uploadFiles();">Upload</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
